import api from "./api";

// Relatórios (Fase 1) — visão geral do período.
const reportsService = {
  overview: (from, to) =>
    api.get("/reports/overview", { params: { from, to } }).then((r) => r.data),
  csat: (from, to) =>
    api.get("/csat/summary", { params: { from, to } }).then((r) => r.data),
};

export default reportsService;
